document.addEventListener("DOMContentLoaded", function () {
  const accordionItems = document.querySelectorAll(".kg-accordion-item");
  const isMerch = !!document.querySelector(".main-containersssss.product-merch-template");

  // Load accordion images eagerly so scrollHeight is correct
  document.querySelectorAll(".kg-accordion-content img").forEach((img) => {
    img.loading = "eager";
  });

  function setOpenHeight(item) {
    const content = item.querySelector(".kg-accordion-content");
    if (content && item.classList.contains("active")) {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  }

  function releaseScrollTriggerPinHeight() {
    if (!isMerch || typeof ScrollTrigger === "undefined") return;

    const container = document.querySelector(".extra-long-container");
    if (!container || container.getBoundingClientRect().width === 0) return;

    container.style.height = "auto";
    container.style.maxHeight = "none";
    ScrollTrigger.refresh();
  }

  function closeItem(item) {
    const content = item.querySelector(".kg-accordion-content");
    item.classList.remove("active");
    if (content) {
      // Reset from "none" to a real value first so the close animates
      content.style.maxHeight = content.scrollHeight + "px";
      requestAnimationFrame(() => {
        content.style.maxHeight = "0px";
      });
    }
  }

  function closeAllItems() {
    accordionItems.forEach((item) => {
      if (item.classList.contains("active")) closeItem(item);
    });
  }

  function openItem(item) {
    const content = item.querySelector(".kg-accordion-content");
    if (!content) return;

    if (item.classList.contains("active")) {
      closeItem(item);
      window.setTimeout(releaseScrollTriggerPinHeight, 400);
      return;
    }

    closeAllItems();
    item.classList.add("active");
    setOpenHeight(item);

    content.querySelectorAll("img").forEach((img) => {
      if (img.complete) return;
      img.addEventListener(
        "load",
        () => {
          setOpenHeight(item);
          releaseScrollTriggerPinHeight();
        },
        { once: true }
      );
    });

    window.setTimeout(() => {
      if (item.classList.contains("active")) content.style.maxHeight = "none";
      releaseScrollTriggerPinHeight();
    }, 500);
  }

  accordionItems.forEach((item) => {
    const header = item.querySelector(".kg-accordion-header");
    if (!header) return;
    header.style.cursor = "pointer";
    header.addEventListener("click", () => openItem(item));
  });

  // Keep open item correct on resize
  window.addEventListener("resize", () => {
    accordionItems.forEach((item) => {
      const content = item.querySelector(".kg-accordion-content");
      if (item.classList.contains("active") && content) {
        content.style.maxHeight = "none";
      }
    });
    releaseScrollTriggerPinHeight();
  });

  if (isMerch) {
    accordionItems.forEach((item) => {
      item.classList.remove("active");
      const content = item.querySelector(".kg-accordion-content");
      if (content) content.style.maxHeight = "0px";
    });
  } else if (accordionItems.length > 0) {
    setTimeout(() => openItem(accordionItems[0]), 100);
  }
});